// App.js
import React, { useState, useEffect } from "react";
import ImageGenerator from "./components/ImageGenerator";
import "./App.css";

const PASSWORD = "V@KINGSRule?";

function App() {
  // authentication state
  const [authenticated, setAuthenticated] = useState(() => {
    return (
      process.env.NODE_ENV === "development" ||
      localStorage.getItem("dreamBatchAuth") === "true"
    );
  });
  const [passwordInput, setPasswordInput] = useState("");

  // config.json loader state
  const [options, setOptions] = useState(null);
  const [configLoaded, setConfigLoaded] = useState(false);

  // fetch config.json 
  useEffect(() => {
    if (!authenticated) return;
    fetch("/config.json?v=" + Date.now()) // cache buster ensures fresh load
      .then((res) => res.json())
      .then((data) => {
        setOptions(data);
        setConfigLoaded(true);
      })
      .catch((err) => {
        console.error("Failed to load config.json", err);
        setConfigLoaded(true);
      });
  }, [authenticated]);

  // password handling
  const handlePasswordSubmit = () => {
    if (passwordInput === PASSWORD) {
      localStorage.setItem("dreamBatchAuth", "true");
      setAuthenticated(true);
    } else {
      alert("Incorrect password");
    }
  };
  const handleKeyDown = (e) => {
    if (e.key === "Enter") handlePasswordSubmit();
  };

  if (!authenticated) {
    return (
      <div
        style={{
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          backgroundColor: "#000",
          color: "white",
          padding: "20px",
        }}
      >
        <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
          <input
            type="password"
            placeholder="Password"
            value={passwordInput}
            onChange={(e) => setPasswordInput(e.target.value)}
            onKeyDown={handleKeyDown}
            style={{
              padding: "10px",
              fontSize: "1rem",
              borderRadius: "4px",
              border: "1px solid #555",
              background: "#111",
              color: "#fff",
              width: "200px",
            }}
          />
          <button
            onClick={handlePasswordSubmit}
            style={{
              padding: "10px 20px",
              fontSize: "1rem",
              backgroundColor: "#00b4d8",
              color: "#000",
              border: "none",
              borderRadius: "4px",
              cursor: "pointer",
            }}
          >
            Submit
          </button>
        </div>
      </div>
    );
  }

  // once authed, wait for config.json
  if (!configLoaded) {
    return <div>Loading configuration…</div>;
  }

  return (
    <div >
      <div className="title">GEMS<span className="titlenb"> - Generative Engine for Media & Stories</span></div>
      <ImageGenerator options={options} />
    </div>
  );
}

export default App;
